export default [
  {
    path: '/painel',
    name: 'painel-stores',
    component: () => import('@/views/painel/painel'),
  },
]
